export default __webpack_public_path__ + "static/media/b2.10fc1e67.jpg";